import script from "./BaseTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTabs.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTabs.vue?vue&type=style&index=0&id=e633cd12&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e633cd12"]])

export default __exports__